(function (angular) {
    'use strict';

    angular
        .module('app')
        .constant('ui', {
            block: block,
            unblock: unblock,
            handleError: handleError,
            systemMessage: systemMessage,
            showNotificationSystemMessage: showNotificationSystemMessage,
            success: function (message) {
                showNotification({ 'type': 'success', 'message': message });
            },
            warning: function (message) {
                showNotification({ 'type': 'warning', 'message': message });
            },
            error: function (message) {
                showNotification({ 'type': 'error', 'message': message });
            },
            info: function (message) {
                showNotification({ 'type': 'info', 'message': message });
            }
        })
        .run(['$rootScope', configure]);

    function configure($rootScope) {
        $rootScope.$on('$stateChangeSuccess', function () {
            $('#toast-container').html('');

            /*
             * This solve the issue for android and chrome when the top header is hidden and you change
             * page the header was still hidden. Removing this class after a successfull change on the sate
             * makes the header visible everytime a new page state renders.
             */
            $('.wrapper-master-nav').removeClass('scrolling-up');
        });

        init();
    }

    var element;
    var key;

    function init() {
        element = document.createElement('div');
        element.className = 'block-ui';
        document.body.appendChild(element);
        var inner = element.appendChild(document.createElement('div'));
        inner.appendChild(document.createElement('div'));
        inner.appendChild(document.createElement('div'));
    }

    function block(zIndex) {
        clearTimeout(key);
        if (zIndex) {
            element.style.zIndex = zIndex;
        } else {
            element.style.zIndex = null;
        }
        element.className = 'block-ui block-ui-active';
        key = setTimeout(function () {
            element.className = 'block-ui block-ui-active block-ui-wait';
        }, 750);
    }

    function unblock() {
        clearTimeout(key);
        element.className = 'block-ui';
    }

    function systemMessage(message) {        
        if (message.messageType == 'Announcement' || message.messageType == 'Banner') {
            switch (message.severity) {
                case 'Low':
                    showNotificationSystemMessage({
                        'type': 'systemMessage',
                        'title': message.title,
                        'closeButton': true,
                        'timeOut': '30000',
                        'position-class': 'toast-top-full-width',
                        'message': message.description
                    });
                    break;
                case 'Medium':
                    showNotificationSystemMessage({
                        'type': 'systemMessage',
                        'title': message.title,
                        'closeButton': true,
                        'timeOut': '30000',
                        'position-class': 'toast-top-full-width',
                        'message': message.description
                    });
                    break;
                case 'High':
                    showNotificationSystemMessage({
                        'type': 'systemMessage',
                        'title': message.title,
                        'closeButton': true,
                        'timeOut': 0,
                        'extendedTimeOut': 0,
                        'showDuration': 0,
                        'hideDuration': 0,
                        'preventDuplicates': true,
                        'disableTimeOut': true,
                        'position-class': 'toast-top-full-width',
                        'debug': true,
                        'message': message.description
                    });
                    break;
            }
        }
    }

    var takeFive = false;

    /**
     * Helps catpure, console log, and display error message.
     * @param {object} errorObject - object representing the error message
     */
    function handleError(errorObject) {
        var finalMsg = PrepareFinalMessage(errorObject);

        // Show toast notification
        if (!takeFive) {
            switch (errorObject.status) {
                case 0:
                    showNotification({
                        'type': 'error',
                        'message': 'Oops!  Something has gone wrong!  Please help us by contacting support.'
                    });
                    break;
                case 200:
                    showNotification({ 'type': 'success', 'message': finalMsg });
                    break;
                case 401:
                    showNotification({
                        'type': 'error',
                        'message': 'Your credentials have expired. Please login again.'
                    });
                    break;
                case 400:
                case 409:
                case 500:
                    showNotification({ 'type': 'error', 'message': finalMsg });
                    break;
                default:
                    showNotification({
                        'type': 'error',
                        'message': 'Oops!  Something has gone wrong!  Please help us by contacting support.'
                    });
            }
        }
    }

    /**
     * Helps display the desired message in specified format.
     * @param {type} options - object representing the message configurations
     * @param {string} type - type of the notification like success/warning/error/info
     * @param {string} message - the message to display
     */
    function showNotification(options) {
        toastr.options = {
            'closeButton': false,
            'debug': false,
            'newestOnTop': false,
            'progressBar': false,
            'positionClass': 'toast-bottom-center pds-toast', // added PDS specific class to override inner styles
            'preventDuplicates': true,
            'preventOpenDuplicates': true,
            'onclick': null,
            'showDuration': '100',
            'hideDuration': '100',
            'timeOut': '3000',
            'extendedTimeOut': '1000',
            'showEasing': 'swing',
            'hideEasing': 'swing',
            'showMethod': 'slideDown',
            'hideMethod': 'slideUp'
        };

        switch (options.type.toLowerCase()) {
            case 'success':
                toastr.success(options.message);
                break;
            case 'warning':
                toastr.warning(options.message);
                break;
            case 'error':
                toastr.error(options.message);
                break;
            case 'info':
                toastr.info(options.message);
                break;
            case 'systemmessage':
                toastr.error(options.message, options.title);
                break;
            default:
                toastr.warning(options.message);
        }
    }

    function showNotificationSystemMessage(options) {
        toastr.options = {
            'closeButton': true,
            'debug': true,
            'newestOnTop': false,
            'progressBar': false,
            'positionClass': 'toast-top-full-width', // added PDS specific class to override inner styles
            'preventDuplicates': true,
            'preventOpenDuplicates': true,
            'onclick': null,
            'showDuration': 0,
            'hideDuration': 0,
            'timeOut': 0,
            'extendedTimeOut': 0,
            'showEasing': 'swing',
            'hideEasing': 'swing',
            'showMethod': 'slideDown',
            'hideMethod': 'slideUp'
        };        
        switch (options.type.toLowerCase()) {
            case 'success':
                toastr.success(options.message);
                break;
            case 'warning':
                toastr.warning(options.message);
                break;
            case 'error':
                toastr.error(options.message);
                break;
            case 'info':
                toastr.info(options.message);
                break;
            case 'systemmessage':
                toastr.info(options.message, options.title);
                break;
            default:
                toastr.warning(options.message);
        }
    }

    /**
     * Private function to extract and form the final error message.
     * @param {object} errorObject
     * @param {object} optionsObject
     * @returns {string} - Returns the final error message.
     */
    function PrepareFinalMessage(errorObject) {
        // Message pieces holders
        var finalMsg = '';
        var errorMessage = '';
        var data = errorObject.data;
        // Extract error message and show stack trace as applicable
        switch (errorObject.status) {
            case 400:
            case 409: // Http status code
                if (data.length) {
                    errorObject.data.forEach(function (entry) {
                        if (entry.hasOwnProperty('message')) {
                            errorMessage = errorMessage + entry.message + '\n';
                        }
                    });
                    //
                } else {
                    if (data.hasOwnProperty('message')) {
                        errorMessage = data.message;
                    }
                }
                break;
            case 500: // Http status code
                var data = errorObject.data;
                if (data.hasOwnProperty('message')) {
                    errorMessage = data.message;
                } else {
                    errorMessage = 'Oops!  Something has gone wrong!  Please help us by contacting support.';
                }
                break;
        }

        // Compile the final message
        finalMsg = errorMessage.length > 0 ? errorMessage + '\n' : ''; //errorMessage.length > 0 ? ("[Error Details] - " + errorMessage + "\n") : '';

        // Console log the error
        console.log(errorObject);

        return finalMsg;
    }

    function waitFive() {
        takeFive = !takeFive;
        setTimeout(function () {
            takeFive = !takeFive;
        }, 5000);
    }
})(angular);
